// ---------------------------------------------------------------------------
// MFE style isolation — MUI v4 (JSS) class-name seed
// ---------------------------------------------------------------------------
// MUI v4 `makeStyles` injects GLOBAL class names into <head> at runtime
// (e.g. `jss1`, `jss2`, … in production). When Sandbox is embedded inside
// StudentPortal, BOTH apps are MUI v4 instances rendering into the SAME
// document, each with its own counter starting at `jss1`. Their generated
// names collide (`.jss42` exists in both), and whichever <style> is inserted
// last wins — which broke the Carousel layout (overflow/flex/flex-basis) and
// any other makeStyles-driven section.
//
// postcss-prefix-selector (craco.config.js) CANNOT fix this — it only scopes
// build-time CSS/SCSS/CSS-modules, not runtime JSS.
//
// Seeding the generator namespaces Sandbox's class names (e.g. `sbx-jss1`) so
// they can never collide with the portal's. Use a single shared instance for
// the whole app, applied via <StylesProvider generateClassName={...}> at both
// entry points (standalone index.js and embedded sandboxPlugin.js).
//
// HOW TO REMOVE (when retiring the MFE): delete this file and the
// <StylesProvider> wrappers — a standalone Sandbox doesn't need the seed.
// ---------------------------------------------------------------------------
import { createGenerateClassName } from "@material-ui/core/styles";

export const sandboxGenerateClassName = createGenerateClassName({
  seed: "sbx",
});
